import { RefreshCw } from 'lucide-react'

/**
 * The Connected schedules list before the lineup has answered (#1142): the
 * loading line, or why the read failed with a Retry, which says it is
 * retrying while the page reads again (the reason stays). One list item, so
 * the panel's list keeps its shape; the alert is the message inside it,
 * since a list's children must stay list items.
 */
export function LineupLoadState({ error = null, retrying = false, onRetry }) {
  if (!error) return <li className="px-1 py-6 text-center text-xs text-[var(--prepacks-muted)]">Loading this surface’s schedules…</li>
  return (
    <li className="flex flex-col items-center gap-2 px-1 py-6 text-center text-xs text-[var(--wf-color-warning)]">
      <span role="alert">This surface’s schedules couldn’t be loaded: {error}.</span>
      {onRetry ? (
        <button type="button" onClick={onRetry} disabled={retrying} className="flex items-center gap-1 rounded border border-[var(--prepacks-border)] px-2 py-1 text-[var(--prepacks-accent-text)] hover:bg-[var(--wf-color-action-soft)] disabled:cursor-default disabled:text-[var(--prepacks-muted)]">
          <RefreshCw className={`h-3 w-3${retrying ? ' motion-safe:animate-spin' : ''}`} aria-hidden="true" />{retrying ? 'Retrying…' : 'Retry'}
        </button>
      ) : null}
    </li>
  )
}
